export const EMOJI_CATEGORIES = [
  {
    key: "frequent",
    label: "Frequently used",
    items: [
      { emoji: "👍", keywords: ["ok", "yes", "good", "approve", "thanks"] },
      { emoji: "✅", keywords: ["done", "complete", "confirmed"] },
      { emoji: "😊", keywords: ["smile", "nice", "happy"] },
      { emoji: "🙏", keywords: ["thanks", "thank you", "appreciate"] },
      { emoji: "❤️", keywords: ["love", "heart"] },
      { emoji: "🎉", keywords: ["yay", "celebrate", "congrats"] },
      { emoji: "👋", keywords: ["hi", "hello", "welcome", "bye"] },
      { emoji: "😂", keywords: ["lol", "funny", "laugh"] },
      { emoji: "🌴", keywords: ["vacation", "palm", "tropical"] },
      { emoji: "🐳", label: "Spouting whale", keywords: ["whale", "whalecome", ":whale:"] },
      { emoji: "🐢", label: "Turtle", keywords: ["turtle", ":turtle:"] },
      { emoji: "🏊‍♀️", label: "Woman swimming", keywords: ["swim", "swimming", "pool", ":woman-swimming:"] }
    ]
  },
  {
    key: "guest",
    label: "Guest & Stay",
    items: [
      { emoji: "🏡", keywords: ["home", "house", "property"] },
      { emoji: "🔑", keywords: ["key", "door", "code", "lock"] },
      { emoji: "🧳", keywords: ["check in", "checkin", "check out", "checkout", "travel", "luggage"] },
      { emoji: "🛏️", keywords: ["bed", "sleep"] },
      { emoji: "🚪", keywords: ["door", "entry"] },
      { emoji: "🚿", keywords: ["shower", "bathroom"] },
      { emoji: "🧼", keywords: ["clean", "cleaning", "soap"] },
      { emoji: "🧽", keywords: ["clean", "wipe"] },
      { emoji: "🧺", keywords: ["laundry", "towels"] },
      { emoji: "🛠️", keywords: ["maintenance", "fix", "repair"] },
      { emoji: "🔧", keywords: ["maintenance", "fix", "repair"] },
      { emoji: "⚠️", keywords: ["important", "warning", "attention"] },
      { emoji: "⏰", keywords: ["time", "late", "schedule"] },
      { emoji: "📍", keywords: ["location", "address", "directions", "pin"] },
      { emoji: "📅", keywords: ["calendar", "date", "booking", "reservation"] },
      { emoji: "🅿️", keywords: ["parking", "car"] },
      { emoji: "📶", keywords: ["wifi", "internet", "network"] },
      { emoji: "🧻", keywords: ["toilet paper", "bathroom", "supplies"] },
      { emoji: "🧴", keywords: ["lotion", "sunscreen", "toiletries", "amenities"] },
      { emoji: "🧹", keywords: ["broom", "clean", "housekeeping"] },
      { emoji: "🗑️", keywords: ["trash", "garbage", "bins"] },
      { emoji: "♻️", keywords: ["recycling", "trash", "eco"] },
      { emoji: "🌡️", keywords: ["temperature", "thermostat", "heat", "air conditioning"] },
      { emoji: "🔥", keywords: ["fireplace", "fire pit", "hot"] },
      { emoji: "❄️", keywords: ["air conditioning", "ac", "cool", "cold"] },
      { emoji: "🛜", keywords: ["wifi", "internet", "network"] },
      { emoji: "🔇", keywords: ["quiet", "noise", "quiet hours"] },
      { emoji: "🐾", keywords: ["pet", "dog", "pet friendly"] }
    ]
  },
  {
    key: "beach-water",
    label: "Beach & Water",
    items: [
      { emoji: "🐳", label: "Spouting whale", keywords: ["whale", "whalecome", "ocean", ":whale:"] },
      { emoji: "🐋", label: "Whale", keywords: ["whale", "whale2", "whalecome", "ocean", ":whale2:"] },
      { emoji: "🐢", label: "Turtle", keywords: ["turtle", "sea turtle", ":turtle:"] },
      { emoji: "🐬", label: "Dolphin", keywords: ["dolphin", "ocean"] },
      { emoji: "🐠", label: "Tropical fish", keywords: ["fish", "tropical", "snorkel"] },
      { emoji: "🦀", label: "Crab", keywords: ["crab", "beach", "seafood"] },
      { emoji: "🐚", label: "Seashell", keywords: ["shell", "seashell", "beach"] },
      { emoji: "🪸", label: "Coral", keywords: ["coral", "reef", "snorkel"] },
      { emoji: "🏖️", label: "Beach with umbrella", keywords: ["beach", "vacation", "sand", "umbrella"] },
      { emoji: "🏊", label: "Person swimming", keywords: ["swim", "swimming", "pool"] },
      { emoji: "🏊‍♀️", label: "Woman swimming", keywords: ["woman", "swim", "swimming", "pool", ":woman-swimming:"] },
      { emoji: "🏊‍♂️", label: "Man swimming", keywords: ["man", "swim", "swimming", "pool"] },
      { emoji: "🤿", label: "Diving mask", keywords: ["snorkel", "scuba", "diving", "ocean"] },
      { emoji: "🏄", label: "Person surfing", keywords: ["surf", "surfing", "ocean"] },
      { emoji: "🛶", label: "Canoe", keywords: ["canoe", "kayak", "paddle", "lake"] },
      { emoji: "⛵", label: "Sailboat", keywords: ["sailboat", "sailing", "boat"] },
      { emoji: "🚤", label: "Speedboat", keywords: ["boat", "speedboat", "water"] },
      { emoji: "⚓", label: "Anchor", keywords: ["anchor", "boat", "marina"] },
      { emoji: "🛟", label: "Life ring", keywords: ["life ring", "lifesaver", "pool", "safety"] },
      { emoji: "🩴", label: "Flip-flops", keywords: ["flip flops", "sandals", "beach"] },
      { emoji: "🕶️", label: "Sunglasses", keywords: ["sunglasses", "sun", "vacation"] },
      { emoji: "⛱️", label: "Umbrella on ground", keywords: ["umbrella", "beach", "shade"] }
    ]
  },
  {
    key: "activities",
    label: "Vacation Activities",
    items: [
      { emoji: "🥾", keywords: ["hike", "hiking", "boots", "trail"] },
      { emoji: "🏕️", keywords: ["camping", "campground", "tent"] },
      { emoji: "🏔️", keywords: ["mountain", "hiking", "view"] },
      { emoji: "🚵", keywords: ["mountain bike", "biking", "cycling"] },
      { emoji: "🚲", keywords: ["bike", "bicycle", "cycling"] },
      { emoji: "🎣", keywords: ["fishing", "fish", "lake"] },
      { emoji: "⛳", keywords: ["golf", "golfing"] },
      { emoji: "🎾", keywords: ["tennis", "court"] },
      { emoji: "🏐", keywords: ["volleyball", "beach"] },
      { emoji: "⛷️", keywords: ["ski", "skiing", "snow"] },
      { emoji: "🏂", keywords: ["snowboard", "snowboarding", "snow"] },
      { emoji: "🛷", keywords: ["sled", "sledding", "snow"] },
      { emoji: "🎟️", keywords: ["ticket", "event", "admission"] },
      { emoji: "📸", keywords: ["photo", "picture", "camera", "memories"] }
    ]
  },
  {
    key: "nature",
    label: "Nature",
    items: [
      { emoji: "🌞", keywords: ["sun", "sunny"] },
      { emoji: "🌧️", keywords: ["rain", "rainy"] },
      { emoji: "❄️", keywords: ["snow", "cold"] },
      { emoji: "🌊", keywords: ["ocean", "wave", "beach"] },
      { emoji: "🌈", keywords: ["rainbow"] },
      { emoji: "🌲", keywords: ["tree", "forest"] },
      { emoji: "🌴", keywords: ["palm", "tropical"] },
      { emoji: "🌸", keywords: ["flower", "spring"] },
      { emoji: "🌺", keywords: ["flower"] },
      { emoji: "🌻", keywords: ["sunflower"] },
      { emoji: "🍂", keywords: ["fall", "autumn", "leaves"] },
      { emoji: "🌅", keywords: ["sunrise", "morning", "view"] },
      { emoji: "🌄", keywords: ["sunrise", "mountain", "view"] },
      { emoji: "🌇", keywords: ["sunset", "evening", "city"] },
      { emoji: "✨", keywords: ["sparkle", "clean", "special"] },
      { emoji: "⭐", keywords: ["star", "review", "favorite"] }
    ]
  },
  {
    key: "food",
    label: "Food & Drink",
    items: [
      { emoji: "☕", keywords: ["coffee"] },
      { emoji: "🍵", keywords: ["tea"] },
      { emoji: "🍕", keywords: ["pizza"] },
      { emoji: "🍔", keywords: ["burger"] },
      { emoji: "🥗", keywords: ["salad"] },
      { emoji: "🍪", keywords: ["cookie"] },
      { emoji: "🍰", keywords: ["cake", "dessert"] },
      { emoji: "🍷", keywords: ["wine"] },
      { emoji: "🥂", keywords: ["cheers", "toast", "celebrate"] },
      { emoji: "🍹", keywords: ["tropical drink", "cocktail", "vacation"] },
      { emoji: "🍽️", keywords: ["restaurant", "dinner", "dining"] },
      { emoji: "🧊", keywords: ["ice", "ice maker", "cold"] },
      { emoji: "🔥", keywords: ["grill", "barbecue", "bbq", "fire"] },
      { emoji: "🧺", keywords: ["picnic", "basket"] }
    ]
  },
  {
    key: "travel",
    label: "Travel",
    items: [
      { emoji: "🚗", keywords: ["car", "drive"] },
      { emoji: "🛻", keywords: ["truck"] },
      { emoji: "🚕", keywords: ["taxi", "uber"] },
      { emoji: "✈️", keywords: ["flight", "plane", "airport"] },
      { emoji: "🗺️", keywords: ["map"] },
      { emoji: "📌", keywords: ["pin", "location"] },
      { emoji: "🧭", keywords: ["compass", "direction"] },
      { emoji: "🚲", keywords: ["bike", "bicycle", "cycling"] },
      { emoji: "🚶", keywords: ["walk", "walking", "directions"] },
      { emoji: "🚢", keywords: ["cruise", "ship", "port"] },
      { emoji: "⛽", keywords: ["gas", "fuel", "gas station"] }
    ]
  },
{
  key: "smileys",
  label: "Smileys",
  items: [
    { emoji: "😀", keywords: ["happy", "smile", "grin"] },
    { emoji: "😄", keywords: ["happy", "smile", "grin"] },
    { emoji: "😊", keywords: ["smile", "friendly"] },
    { emoji: "🙂", keywords: ["smile", "okay"] },
    { emoji: "😉", keywords: ["wink"] },
    { emoji: "😍", keywords: ["love", "heart eyes"] },
    { emoji: "🥰", keywords: ["love", "cute"] },
    { emoji: "🤩", keywords: ["excited", "star"] },

    { emoji: "😂", keywords: ["lol", "laugh"] },
    { emoji: "🤣", keywords: ["rofl", "laugh"] },
    { emoji: "😅", keywords: ["sweat", "oops", "awkward"] },
    { emoji: "🤭", keywords: ["oops", "giggle"] },

    { emoji: "😮", keywords: ["wow", "surprised"] },
    { emoji: "😲", keywords: ["shocked", "surprise"] },
    { emoji: "😳", keywords: ["embarrassed", "oops"] },

    { emoji: "😌", keywords: ["relieved", "calm"] },
    { emoji: "🥹", keywords: ["touched", "thankful"] },

    { emoji: "😕", keywords: ["confused", "unsure"] },
    { emoji: "🙁", keywords: ["sad", "unhappy"] },
    { emoji: "😢", keywords: ["sad", "tear"] },
    { emoji: "😭", keywords: ["cry", "very sad"] },

    { emoji: "😤", keywords: ["frustrated", "annoyed"] },
    { emoji: "😡", keywords: ["angry", "mad"] }
  ]
},
  {
    key: "hearts",
    label: "Hearts",
    items: [
      { emoji: "❤️", keywords: ["heart", "love"] },
      { emoji: "💛", keywords: ["heart", "love"] },
      { emoji: "💚", keywords: ["heart", "love"] },
      { emoji: "💙", keywords: ["heart", "love"] },
      { emoji: "💜", keywords: ["heart", "love"] },
      { emoji: "🖤", keywords: ["heart", "love"] },
      { emoji: "🤍", keywords: ["heart", "love"] },
      { emoji: "💔", keywords: ["heart", "sad"] },
      { emoji: "❣️", keywords: ["heart", "love"] },
      { emoji: "💖", keywords: ["heart", "love"] }
    ]
  }
];
